// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./client/index.scss
// module id = 2
// module chunks = 0